/**
 * Protected Route Component
 * Requires authentication to access
 */

import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

    // Show loading state while checking authentication
    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <div className="text-center">
                    <div className="spinner-lighthouse mb-3"></div>
                    <p className="text-muted">Verifying authentication...</p>
                </div>
            </div>
        );
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        loginWithRedirect({
            appState: { returnTo: window.location.pathname }
        });
        return null;
    }

    // Render protected content if authenticated
    return children;
}

export default ProtectedRoute;
